const shadowLine = (ctx: CanvasRenderingContext2D, shadowColor: string, x: number, y: number) => {
  ctx.lineWidth = 1.5
  ctx.strokeStyle = shadowColor
  ctx.beginPath()
  ctx.moveTo(461 + x, 528 + y) // 左下
  ctx.quadraticCurveTo(469 + x, 518 + y, 493 + x, 513 + y) // 右上
  ctx.moveTo(461 + x, 557 + y) // 左下
  ctx.quadraticCurveTo(461 + x, 539 + y, 497 + x, 514 + y) // 右上
  ctx.moveTo(465 + x, 561 + y) // 左下
  ctx.quadraticCurveTo(472 + x, 561 + y, 476 + x, 557 + y) // 右上
  ctx.moveTo(483 + x, 565 + y) // 左下
  ctx.quadraticCurveTo(494 + x, 558 + y, 491 + x, 553 + y) // 右上
  ctx.moveTo(514 + x, 517 + y) // 左下
  ctx.quadraticCurveTo(532 + x, 519 + y, 541 + x, 500 + y) // 右上
  ctx.moveTo(454 + x, 574 + y) // 左下
  ctx.quadraticCurveTo(490 + x, 582 + y, 513 + x, 551 + y) // 右上
  ctx.moveTo(500 + x, 527 + y) // 左下
  ctx.quadraticCurveTo(507 + x, 519 + y, 506 + x, 515 + y) //
  ctx.moveTo(506 + x, 531 + y) // 左下
  ctx.quadraticCurveTo(513 + x, 525 + y, 514 + x, 517 + y) //

  // 以下は筆記体文字部分
  // t
  ctx.moveTo(477 + x, 551 + y) // 左下
  ctx.quadraticCurveTo(486 + x, 548 + y, 487 + x, 543 + y) // 右上
  ctx.moveTo(483 + x, 545 + y) // 左下
  ctx.quadraticCurveTo(486 + x, 536 + y, 485 + x, 535 + y) // 上
  ctx.quadraticCurveTo(490 + x, 534 + y, 492 + x, 528 + y) // 右上
  // r
  ctx.moveTo(489 + x, 547 + y) // 左下
  ctx.quadraticCurveTo(493 + x, 549 + y, 496 + x, 544 + y) // 右上
  ctx.moveTo(491 + x, 545 + y) // 左下
  ctx.quadraticCurveTo(494 + x, 535 + y, 494 + x, 537 + y) // 上
  ctx.quadraticCurveTo(498 + x, 537 + y, 499 + x, 534 + y) // 右上
  // e
  ctx.moveTo(496 + x, 542 + y) // 左下
  ctx.quadraticCurveTo(500 + x, 550 + y, 503 + x, 542 + y) // 右上
  ctx.moveTo(499 + x, 542 + y) // 左下
  ctx.quadraticCurveTo(503 + x, 535 + y, 505 + x, 535 + y) // 右上
  // a
  ctx.moveTo(505 + x, 544 + y) // 左下
  ctx.quadraticCurveTo(515 + x, 538 + y, 514 + x, 529 + y) // 右上
  ctx.moveTo(507 + x, 539 + y) // 下
  ctx.quadraticCurveTo(509 + x, 535 + y, 509 + x, 535 + y) // 上
  ctx.moveTo(506 + x, 532 + y) // 右下
  ctx.quadraticCurveTo(502 + x, 528 + y, 502 + x, 528 + y) // 左上
  // s
  ctx.moveTo(512 + x, 541 + y) // 左下
  ctx.quadraticCurveTo(519 + x, 541 + y, 519 + x, 541 + y) // 右下
  ctx.quadraticCurveTo(522 + x, 530 + y, 522 + x, 530 + y) // 上
  ctx.quadraticCurveTo(523 + x, 523 + y, 523 + x, 523 + y) // 右上
  // u
  ctx.moveTo(523 + x, 537 + y) // 左下
  ctx.quadraticCurveTo(527 + x, 538 + y, 531 + x, 535 + y) // 右下
  ctx.moveTo(530 + x, 532 + y) // 下
  ctx.quadraticCurveTo(532 + x, 523 + y, 532 + x, 523 + y) // 上
  // r
  ctx.moveTo(532 + x, 537 + y) // 左下
  ctx.quadraticCurveTo(537 + x, 532 + y, 537 + x, 533 + y) // 右下
  ctx.moveTo(534 + x, 532 + y) // 左下
  ctx.quadraticCurveTo(536 + x, 525 + y, 536 + x, 525 + y) // 上
  ctx.quadraticCurveTo(540 + x, 523 + y, 540 + x, 523 + y) // 右上
  // e
  ctx.moveTo(538 + x, 531 + y) // 左下
  ctx.quadraticCurveTo(542 + x, 534 + y, 542 + x, 534 + y) // 下
  ctx.quadraticCurveTo(545 + x, 529 + y, 546 + x, 529 + y) // 右上
  ctx.moveTo(542 + x, 531 + y) // 左下
  ctx.quadraticCurveTo(544 + x, 526 + y, 547 + x, 524 + y) // 下
  ctx.stroke()
}
// メーカーラベル
const labelBase = (ctx: CanvasRenderingContext2D, standColor: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#bbb'
  ctx.fillStyle = standColor
  // メインカラー↓
  ctx.beginPath()
  ctx.moveTo(446 + x, 531 + y) // 左
  ctx.quadraticCurveTo(420 + x, 558 + y, 443 + x, 579 + y) // 左下
  ctx.quadraticCurveTo(465 + x, 595 + y, 498 + x, 577 + y) //
  ctx.quadraticCurveTo(513 + x, 569 + y, 521 + x, 556 + y) //
  ctx.quadraticCurveTo(522 + x, 548 + y, 538 + x, 546 + y) //
  ctx.quadraticCurveTo(554 + x, 542 + y, 551 + x, 538 + y) // 右下
  ctx.quadraticCurveTo(554 + x, 528 + y, 556 + x, 524 + y) //
  ctx.quadraticCurveTo(554 + x, 515 + y, 554 + x, 515 + y) //
  ctx.quadraticCurveTo(551 + x, 506 + y, 544 + x, 510 + y) //
  ctx.quadraticCurveTo(554 + x, 501 + y, 539 + x, 487 + y) //
  ctx.quadraticCurveTo(536 + x, 484 + y, 533 + x, 487 + y) //
  ctx.quadraticCurveTo(527 + x, 499 + y, 514 + x, 494 + y) //
  ctx.quadraticCurveTo(488 + x, 486 + y, 459 + x, 509 + y) //
  ctx.quadraticCurveTo(445 + x, 517 + y, 446 + x, 531 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const edgeLine = (ctx: CanvasRenderingContext2D, mainColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#bbb'
  ctx.fillStyle = mainColor
  ctx.beginPath()
  ctx.moveTo(460 + x, 528 + y) // 左下
  ctx.quadraticCurveTo(478 + x, 514 + y, 493 + x, 514 + y) //
  ctx.quadraticCurveTo(453 + x, 529 + y, 443 + x, 552 + y) //
  ctx.quadraticCurveTo(435 + x, 578 + y, 478 + x, 576 + y) //
  ctx.quadraticCurveTo(500 + x, 568 + y, 513 + x, 551 + y) //
  ctx.quadraticCurveTo(516 + x, 545 + y, 510 + x, 546 + y) //
  ctx.quadraticCurveTo(497 + x, 559 + y, 483 + x, 565 + y) //
  ctx.quadraticCurveTo(492 + x, 559 + y, 491 + x, 554 + y) //
  ctx.quadraticCurveTo(490 + x, 550 + y, 487 + x, 552 + y) //
  ctx.quadraticCurveTo(484 + x, 558 + y, 477 + x, 564 + y) //
  ctx.quadraticCurveTo(470 + x, 565 + y, 464 + x, 562 + y) //
  ctx.quadraticCurveTo(472 + x, 560 + y, 475 + x, 557 + y) //
  ctx.quadraticCurveTo(477 + x, 550 + y, 469 + x, 552 + y) //
  ctx.quadraticCurveTo(461 + x, 556 + y, 461 + x, 556 + y) //
  ctx.quadraticCurveTo(469 + x, 532 + y, 486 + x, 524 + y) //
  ctx.quadraticCurveTo(493 + x, 520 + y, 496 + x, 514 + y) //
  ctx.quadraticCurveTo(490 + x, 525 + y, 490 + x, 525 + y) //
  ctx.quadraticCurveTo(498 + x, 531 + y, 500 + x, 533 + y) //
  ctx.quadraticCurveTo(508 + x, 516 + y, 508 + x, 516 + y) //
  ctx.quadraticCurveTo(502 + x, 527 + y, 502 + x, 527 + y) //
  ctx.quadraticCurveTo(505 + x, 534 + y, 508 + x, 528 + y) //
  ctx.quadraticCurveTo(511 + x, 526 + y, 514 + x, 517 + y) //
  ctx.quadraticCurveTo(530 + x, 520 + y, 541 + x, 499 + y) // 上1
  ctx.quadraticCurveTo(539 + x, 492 + y, 538 + x, 495 + y) // 上2
  ctx.quadraticCurveTo(525 + x, 510 + y, 509 + x, 502 + y) //
  ctx.quadraticCurveTo(485 + x, 498 + y, 458 + x, 523 + y) //
  ctx.quadraticCurveTo(455 + x, 528 + y, 460 + x, 528 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
const treasureFontT = (ctx: CanvasRenderingContext2D, mainColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#bbb'
  ctx.fillStyle = mainColor
  // T
  ctx.beginPath()
  ctx.moveTo(473 + x, 538 + y) // 左下
  ctx.quadraticCurveTo(470 + x, 545 + y, 475 + x, 551 + y) //
  ctx.quadraticCurveTo(485 + x, 550 + y, 487 + x, 542 + y) //
  ctx.quadraticCurveTo(483 + x, 545 + y, 483 + x, 545 + y) //
  ctx.quadraticCurveTo(486 + x, 534 + y, 486 + x, 534 + y) //
  ctx.quadraticCurveTo(491 + x, 533 + y, 492 + x, 527 + y) //
  ctx.quadraticCurveTo(487 + x, 531 + y, 482 + x, 530 + y) //
  ctx.quadraticCurveTo(472 + x, 533 + y, 472 + x, 537 + y) //
  ctx.quadraticCurveTo(473 + x, 538 + y, 473 + x, 538 + y) //
  ctx.quadraticCurveTo(477 + x, 535 + y, 477 + x, 535 + y) //
  ctx.quadraticCurveTo(473 + x, 538 + y, 473 + x, 538 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
const treasureFontRE = (ctx: CanvasRenderingContext2D, mainColor: string, shadowColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#bbb'
  ctx.fillStyle = mainColor
  // r
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#bbb'
  ctx.fillStyle = mainColor
  ctx.beginPath()
  ctx.moveTo(497 + x, 532 + y) // 右上
  ctx.quadraticCurveTo(492 + x, 532 + y, 492 + x, 532 + y)
  ctx.quadraticCurveTo(487 + x, 546 + y, 487 + x, 546 + y)
  ctx.quadraticCurveTo(491 + x, 548 + y, 491 + x, 548 + y)
  ctx.quadraticCurveTo(496 + x, 543 + y, 496 + x, 543 + y) //右下
  ctx.quadraticCurveTo(491 + x, 544 + y, 491 + x, 544 + y)
  ctx.quadraticCurveTo(494 + x, 536 + y, 494 + x, 536 + y)
  ctx.quadraticCurveTo(498 + x, 537 + y, 499 + x, 533 + y)
  ctx.quadraticCurveTo(497 + x, 532 + y, 497 + x, 532 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // e
  // e の本体
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#bbb'
  ctx.beginPath()
  ctx.moveTo(497 + x, 543 + y) // 左下
  ctx.quadraticCurveTo(499 + x, 545 + y, 500 + x, 546 + y)
  ctx.quadraticCurveTo(503 + x, 541 + y, 503 + x, 541 + y)
  ctx.quadraticCurveTo(496 + x, 544 + y, 506 + x, 535 + y)
  ctx.quadraticCurveTo(501 + x, 526 + y, 499 + x, 532 + y)
  ctx.quadraticCurveTo(499 + x, 536 + y, 497 + x, 543 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // e の丸穴
  ctx.lineWidth = 0.8
  ctx.strokeStyle = shadowColor
  ctx.fillStyle = shadowColor
  ctx.beginPath()
  ctx.moveTo(502 + x, 533 + y)
  ctx.quadraticCurveTo(501 + x, 534 + y, 501 + x, 534 + y)
  ctx.quadraticCurveTo(502 + x, 535 + y, 502 + x, 535 + y)
  ctx.quadraticCurveTo(503 + x, 534 + y, 503 + x, 534 + y)
  ctx.quadraticCurveTo(502 + x, 535 + y, 502 + x, 535 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const treasureFontASU = (ctx: CanvasRenderingContext2D, mainColor: string, shadowColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = mainColor
  ctx.fillStyle = mainColor
  // a
  ctx.beginPath()
  ctx.moveTo(507 + x, 533 + y) // 左上
  ctx.quadraticCurveTo(505 + x, 529 + y, 514 + x, 528 + y)
  ctx.quadraticCurveTo(512 + x, 538 + y, 512 + x, 538 + y) // 右下
  ctx.quadraticCurveTo(506 + x, 544 + y, 506 + x, 544 + y) // 左下
  ctx.quadraticCurveTo(501 + x, 538 + y, 509 + x, 533 + y) //
  ctx.quadraticCurveTo(505 + x, 537 + y, 507 + x, 540 + y) //
  ctx.quadraticCurveTo(509 + x, 536 + y, 509 + x, 536 + y) //
  ctx.quadraticCurveTo(510 + x, 532 + y, 510 + x, 532 + y) //
  ctx.quadraticCurveTo(507 + x, 533 + y, 507 + x, 533 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // s
  ctx.beginPath()
  ctx.moveTo(509 + x, 542 + y) // 左下
  ctx.quadraticCurveTo(512 + x, 539 + y, 518 + x, 541 + y)
  ctx.quadraticCurveTo(523 + x, 534 + y, 521 + x, 529 + y)
  ctx.quadraticCurveTo(524 + x, 527 + y, 523 + x, 521 + y) // 右上
  ctx.quadraticCurveTo(521 + x, 526 + y, 518 + x, 525 + y)
  ctx.quadraticCurveTo(515 + x, 527 + y, 515 + x, 533 + y)
  ctx.quadraticCurveTo(515 + x, 537 + y, 509 + x, 542 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // sの穴2つ
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = shadowColor
  ctx.moveTo(518 + x, 529 + y) //
  ctx.quadraticCurveTo(518 + x, 530 + y, 518 + x, 531 + y)
  ctx.quadraticCurveTo(519 + x, 530 + y, 520 + x, 531 + y)
  ctx.quadraticCurveTo(519 + x, 529 + y, 520 + x, 530 + y)
  ctx.quadraticCurveTo(518 + x, 529 + y, 518 + x, 529 + y)
  ctx.moveTo(517 + x, 534 + y) //
  ctx.quadraticCurveTo(517 + x, 535 + y, 517 + x, 536 + y)
  ctx.quadraticCurveTo(518 + x, 535 + y, 519 + x, 536 + y)
  ctx.quadraticCurveTo(517 + x, 534 + y, 519 + x, 534 + y)
  ctx.quadraticCurveTo(517 + x, 534 + y, 517 + x, 534 + y)
  ctx.stroke()
  ctx.closePath()
  // u
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#bbb'
  ctx.fillStyle = mainColor
  ctx.moveTo(524 + x, 524 + y) // 左上
  ctx.quadraticCurveTo(523 + x, 529 + y, 523 + x, 529 + y)
  ctx.quadraticCurveTo(524 + x, 534 + y, 522 + x, 536 + y)
  ctx.quadraticCurveTo(524 + x, 539 + y, 526 + x, 537 + y)
  ctx.quadraticCurveTo(529 + x, 537 + y, 530 + x, 536 + y)
  ctx.quadraticCurveTo(529 + x, 528 + y, 532 + x, 524 + y)
  ctx.quadraticCurveTo(531 + x, 521 + y, 527 + x, 520 + y) // 右上
  ctx.quadraticCurveTo(528 + x, 526 + y, 528 + x, 526 + y)
  ctx.quadraticCurveTo(526 + x, 528 + y, 526 + x, 533 + y)
  ctx.quadraticCurveTo(527 + x, 526 + y, 524 + x, 524 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // u中央垂直の影
  ctx.lineWidth = 0.9
  ctx.strokeStyle = shadowColor
  ctx.beginPath()
  ctx.moveTo(527 + x, 524 + y) // 左上
  ctx.quadraticCurveTo(527 + x, 530 + y, 526 + x, 534 + y)
  ctx.stroke()
  ctx.closePath()
}

const hollowOutOnFont = (ctx: CanvasRenderingContext2D, shadowColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = shadowColor
  ctx.fillStyle = shadowColor
  ctx.beginPath()
  ctx.moveTo(477 + x, 545 + y) // 下
  ctx.quadraticCurveTo(480 + x, 540 + y, 480 + x, 535 + y) // 上
  ctx.quadraticCurveTo(473 + x, 539 + y, 477 + x, 546 + y) // 下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  ctx.beginPath()
  ctx.moveTo(483 + x, 535 + y) // 上
  ctx.quadraticCurveTo(483 + x, 541 + y, 480 + x, 547 + y) // 上
  ctx.stroke()
  ctx.closePath()
}

export const treasureLabel = (
  ctx: CanvasRenderingContext2D,
  mainColor: string,
  shadowColor: string,
  standColor: string,
  x: number,
  y: number,
  numerator: number,
  scaleSize: number
): void => {
  ctx.save()
  ctx.rotate((numerator * Math.PI) / 180)
  ctx.scale(scaleSize, scaleSize)
  labelBase(ctx, standColor, x, y)
  edgeLine(ctx, mainColor, x, y)
  treasureFontT(ctx, mainColor, x, y)
  treasureFontRE(ctx, mainColor, shadowColor, x, y)
  treasureFontASU(ctx, mainColor, shadowColor, x, y)
  treasureFontRE(ctx, mainColor, shadowColor, x + 42, y + -12)
  hollowOutOnFont(ctx, shadowColor, x, y)
  shadowLine(ctx, shadowColor, x, y)
  ctx.restore()
}

const treasureEngravedRE = (ctx: CanvasRenderingContext2D, x: number, y: number) => {
  ctx.lineWidth = 0.8
  // R
  ctx.beginPath()
  ctx.moveTo(461 + x, 389 + y) // 左下
  ctx.quadraticCurveTo(464 + x, 391 + y, 464 + x, 391 + y) //
  ctx.quadraticCurveTo(468 + x, 386 + y, 468 + x, 386 + y) //
  ctx.quadraticCurveTo(465 + x, 386 + y, 465 + x, 386 + y) //
  ctx.quadraticCurveTo(468 + x, 379 + y, 468 + x, 379 + y) //
  ctx.quadraticCurveTo(472 + x, 380 + y, 474 + x, 376 + y) //
  ctx.quadraticCurveTo(466 + x, 375 + y, 466 + x, 375 + y) //
  ctx.quadraticCurveTo(462 + x, 378 + y, 462 + x, 378 + y) //
  ctx.quadraticCurveTo(464 + x, 379 + y, 464 + x, 379 + y) //
  ctx.quadraticCurveTo(461 + x, 389 + y, 461 + x, 389 + y) //
  ctx.stroke()
  ctx.closePath()
  // E
  ctx.beginPath()
  ctx.moveTo(471 + x, 389 + y) // 左下
  ctx.quadraticCurveTo(476 + x, 390 + y, 476 + x, 390 + y) //
  ctx.quadraticCurveTo(482 + x, 387 + y, 482 + x, 384 + y) //
  ctx.quadraticCurveTo(477 + x, 386 + y, 477 + x, 386 + y) //
  ctx.quadraticCurveTo(486 + x, 378 + y, 485 + x, 377 + y) //
  ctx.quadraticCurveTo(480 + x, 373 + y, 475 + x, 377 + y) //
  ctx.quadraticCurveTo(471 + x, 389 + y, 471 + x, 389 + y) //
  ctx.moveTo(476 + x, 382 + y) // 左下
  ctx.quadraticCurveTo(479 + x, 382 + y, 479 + x, 382 + y) //
  ctx.quadraticCurveTo(481 + x, 378 + y, 481 + x, 378 + y) //
  ctx.quadraticCurveTo(476 + x, 378 + y, 476 + x, 378 + y) //
  ctx.quadraticCurveTo(476 + x, 382 + y, 476 + x, 382 + y) //
  ctx.stroke()
  ctx.closePath()
}

// 捕球面の刻印
export const treasureEngravedOfCatchFace = (ctx: CanvasRenderingContext2D, x: number, y: number, leatherColor: string): void => {
  const isBright = ['black', 'navy', 'blue', 'purple', 'chocolate', 'green', 'mGreen', 'silver'].includes(leatherColor)
  ctx.lineWidth = 0.8
  ctx.strokeStyle = isBright ? '#eee' : '#6d6d6d'

  // treasureマーク
  ctx.beginPath()
  ctx.save()
  ctx.scale(1.2, 1.2)

  ctx.moveTo(424 + x, 363 + y) // 左下
  ctx.quadraticCurveTo(456 + x, 351 + y, 474 + x, 356 + y) //
  ctx.quadraticCurveTo(422 + x, 366 + y, 408 + x, 384 + y) //
  ctx.quadraticCurveTo(399 + x, 397 + y, 425 + x, 408 + y) //
  ctx.quadraticCurveTo(462 + x, 416 + y, 494 + x, 396 + y) // 右下
  ctx.quadraticCurveTo(491 + x, 395 + y, 491 + x, 395 + y) //
  ctx.quadraticCurveTo(451 + x, 414 + y, 426 + x, 397 + y) //
  ctx.quadraticCurveTo(414 + x, 375 + y, 472 + x, 358 + y) //
  ctx.quadraticCurveTo(447 + x, 388 + y, 425 + x, 395 + y) //
  ctx.quadraticCurveTo(455 + x, 400 + y, 487 + x, 358 + y) //
  ctx.quadraticCurveTo(493 + x, 360 + y, 493 + x, 360 + y) //
  ctx.quadraticCurveTo(466 + x, 392 + y, 447 + x, 404 + y) //
  ctx.quadraticCurveTo(452 + x, 405 + y, 452 + x, 405 + y) //
  ctx.quadraticCurveTo(476 + x, 387 + y, 497 + x, 360 + y) //
  ctx.quadraticCurveTo(521 + x, 362 + y, 533 + x, 345 + y) // 右上
  ctx.quadraticCurveTo(534 + x, 342 + y, 530 + x, 343 + y) //
  ctx.quadraticCurveTo(515 + x, 355 + y, 489 + x, 347 + y) //
  ctx.quadraticCurveTo(455 + x, 343 + y, 424 + x, 363 + y) //
  ctx.stroke()
  ctx.closePath()
  // T
  ctx.beginPath()
  ctx.moveTo(440 + x, 378 + y) // 左下
  ctx.quadraticCurveTo(446 + x, 376 + y, 447 + x, 375 + y) //
  ctx.quadraticCurveTo(434 + x, 384 + y, 443 + x, 391 + y) //
  ctx.quadraticCurveTo(452 + x, 393 + y, 461 + x, 385 + y) //
  ctx.quadraticCurveTo(458 + x, 384 + y, 458 + x, 384 + y) //
  ctx.quadraticCurveTo(452 + x, 389 + y, 447 + x, 387 + y) //
  ctx.quadraticCurveTo(441 + x, 382 + y, 450 + x, 376 + y) //
  ctx.quadraticCurveTo(447 + x, 387 + y, 447 + x, 387 + y) //
  ctx.moveTo(452 + x, 387 + y)
  ctx.quadraticCurveTo(456 + x, 376 + y, 456 + x, 376 + y) //
  ctx.quadraticCurveTo(462 + x, 375 + y, 465 + x, 370 + y) //
  ctx.quadraticCurveTo(458 + x, 372 + y, 452 + x, 370 + y) //
  ctx.quadraticCurveTo(443 + x, 372 + y, 440 + x, 378 + y) //
  ctx.stroke()
  ctx.closePath()
  // RE
  treasureEngravedRE(ctx, x, y)
  // A
  ctx.beginPath()
  ctx.moveTo(485 + x, 389 + y) // 左下
  ctx.quadraticCurveTo(489 + x, 386 + y, 489 + x, 386 + y) //
  ctx.quadraticCurveTo(492 + x, 389 + y, 492 + x, 389 + y) //
  ctx.quadraticCurveTo(497 + x, 386 + y, 496 + x, 383 + y) //
  ctx.quadraticCurveTo(498 + x, 374 + y, 499 + x, 374 + y) //
  ctx.quadraticCurveTo(495 + x, 374 + y, 493 + x, 372 + y) //
  ctx.quadraticCurveTo(487 + x, 375 + y, 487 + x, 375 + y) //
  ctx.quadraticCurveTo(488 + x, 380 + y, 488 + x, 380 + y) //
  ctx.quadraticCurveTo(482 + x, 384 + y, 485 + x, 389 + y) //
  ctx.moveTo(488 + x, 384 + y) //
  ctx.quadraticCurveTo(492 + x, 383 + y, 492 + x, 383 + y) //
  ctx.quadraticCurveTo(492 + x, 380 + y, 492 + x, 380 + y) //
  ctx.quadraticCurveTo(490 + x, 381 + y, 490 + x, 381 + y) //
  ctx.quadraticCurveTo(489 + x, 384 + y, 489 + x, 384 + y) //
  ctx.moveTo(491 + x, 378 + y) //
  ctx.quadraticCurveTo(494 + x, 378 + y, 494 + x, 378 + y) //
  ctx.quadraticCurveTo(494 + x, 375 + y, 494 + x, 375 + y) //
  ctx.quadraticCurveTo(491 + x, 375 + y, 491 + x, 375 + y) //
  ctx.quadraticCurveTo(491 + x, 378 + y, 491 + x, 378 + y) //
  ctx.stroke()
  ctx.closePath()
  // S
  ctx.beginPath()
  ctx.moveTo(496 + x, 388 + y) // 左下
  ctx.quadraticCurveTo(500 + x, 387 + y, 500 + x, 387 + y) //
  ctx.quadraticCurveTo(508 + x, 390 + y, 511 + x, 380 + y) //
  ctx.quadraticCurveTo(508 + x, 376 + y, 513 + x, 374 + y) //
  ctx.quadraticCurveTo(504 + x, 370 + y, 501 + x, 375 + y) //
  ctx.quadraticCurveTo(499 + x, 380 + y, 499 + x, 380 + y) //
  ctx.quadraticCurveTo(503 + x, 382 + y, 496 + x, 388 + y) //
  ctx.moveTo(503 + x, 384 + y) //
  ctx.quadraticCurveTo(506 + x, 384 + y, 507 + x, 381 + y) //
  ctx.quadraticCurveTo(504 + x, 382 + y, 503 + x, 384 + y) //
  ctx.moveTo(504 + x, 379 + y) //
  ctx.quadraticCurveTo(508 + x, 375 + y, 508 + x, 375 + y) //
  ctx.quadraticCurveTo(503 + x, 374 + y, 504 + x, 379 + y) //
  ctx.stroke()
  ctx.closePath()
  // U
  ctx.beginPath()
  ctx.moveTo(511 + x, 385 + y) // 左下
  ctx.quadraticCurveTo(516 + x, 387 + y, 516 + x, 387 + y) //
  ctx.quadraticCurveTo(519 + x, 383 + y, 519 + x, 383 + y) //
  ctx.quadraticCurveTo(523 + x, 387 + y, 523 + x, 387 + y) //
  ctx.quadraticCurveTo(527 + x, 384 + y, 527 + x, 384 + y) // 右下
  ctx.quadraticCurveTo(524 + x, 381 + y, 524 + x, 381 + y) //
  ctx.quadraticCurveTo(527 + x, 371 + y, 527 + x, 371 + y) // 右上
  ctx.quadraticCurveTo(524 + x, 367 + y, 523 + x, 371 + y) // 右上
  ctx.quadraticCurveTo(520 + x, 380 + y, 521 + x, 380 + y) //
  ctx.quadraticCurveTo(518 + x, 381 + y, 517 + x, 379 + y) //
  ctx.quadraticCurveTo(518 + x, 377 + y, 519 + x, 370 + y) //
  ctx.quadraticCurveTo(514 + x, 370 + y, 514 + x, 370 + y) //
  ctx.quadraticCurveTo(515 + x, 377 + y, 511 + x, 385 + y) //
  ctx.stroke()
  ctx.closePath()
  // RE
  treasureEngravedRE(ctx, x + 65, y + -5)
  ctx.restore()
}
